<script setup lang="ts">
import { getKeurtApiClient } from "../instances/KeurtApiClient";
import InputText from "primevue/inputtext";

const keurtApiClient = getKeurtApiClient();
const email = ref<string>();
const submitted = ref<boolean>(false);
const showComfirmPage = ref<boolean>(false);
const emailErrorMessage = ref<string>("verplicht veld");

const requestPasswordReset = () => {
  submitted.value = true;
  if(!email.value) {
    emailErrorMessage.value = "verplicht veld";
    return;
  }
  if(!validateEmail(email.value))
  {
    emailErrorMessage.value = "E-mailadres is niet correct";
    return;
  }
  keurtApiClient
    .post(`/api/user/requestpasswordreset/${email.value}`)
    .then(() => {
      showComfirmPage.value = true;
    })
}

const validateEmail = (email:string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

</script>

<template>
  <div class="grid min-h-screen place-content-center bg-app-background">
    <div class="w-80">
      <div class="theme-logo bg-center flex flex-fill justify-center h-60" />
        <div v-if="!showComfirmPage">
          <p class="text-[#2D3142] text-center text-xl">Wachtwoord vergeten?</p>
          <br/>
          <p class="text-[#2D3142] text-sm text-center">Vul je e-mailadres in en je ontvangt een link om een nieuw wachtwoord in te stellen.</p>
          <div class="flex flex-col mt-9 mb-6">
            <label
              for="password"
              class="text-sm text-[#556D85]"
            >E-mailadres</label>
            <InputText
              v-model="email"
              type="email"
              name="email"
              @keyup.enter="requestPasswordReset()"
              class="rounded-full"
              :class="{'p-invalid': submitted && !email}"
            />
            <small
              v-if="submitted && (!email || !validateEmail(email))"
              class="p-error"
            >{{ emailErrorMessage }}</small>
          </div>
          <Button
            class="w-80"
              label="Versturen"
              rounded
              @click="requestPasswordReset()"
          />
          <br/>
          <a class="flex justify-evenly mt-4" href="/login"><p class="text-[#FF6828]">Terug naar Inloggen</p></a>
        </div>
        <div v-else>
          <p class="text-[#2D3142] text-center text-xl">Bedankt!</p>
          <br/>
          <p class="text-[#2D3142] text-sm text-center">Wij hebben de link verstuurd, controleer je mailbox.</p>
        </div>
      </div>
    </div>
</template>
